import deepcopy from "deepcopy";
import {
	LIST_LIST_INTERESTS_SUCCESS,
	LIST_LIST_INTERESTS_FAILURE,
	LIST_INTERESTS_RESET,
	ADD_LIST_INTEREST,
	DELETE_LIST_INTEREST,
	REMOVE_NEW_LIST_INTEREST,
} from "./types";
let INITIAL_STATE = {
	listInterests: null,
};
export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case LIST_LIST_INTERESTS_SUCCESS:
		return {
			...state,
			listInterests: { listId: action.listId, listInterests: action.data },
		};
	case ADD_LIST_INTEREST: {
		const updatedState = deepcopy(state);
		updatedState.listInterests.listInterests.data.push(action.data);
		return updatedState;
	}
	case REMOVE_NEW_LIST_INTEREST: {
		const updatedState = deepcopy(state);
		updatedState.listInterests.listInterests.data =
				updatedState.listInterests.listInterests.data.filter(
					(i) => i.id != "##new##"
				);
		return updatedState;
	}
	case DELETE_LIST_INTEREST: {
		const updatedState = deepcopy(state);
		updatedState.listInterests.listInterests.data =
				updatedState.listInterests.listInterests.data.filter(
					(interest) => interest.name != action.name
				);
		return updatedState;
	}
	case LIST_INTERESTS_RESET: {
		return INITIAL_STATE;
	}
	default:
		return state;
	}
};
